import React, {useState, useRef} from 'react'
import styled from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';
import {BsEyeSlash, BsEyeFill, BsTrash, BsExclamationCircleFill, BsExclamationCircle} from 'react-icons/bs';
import {BiDotsVerticalRounded} from 'react-icons/bi';
import {VscChromeClose} from 'react-icons/vsc';
import {FiCheck} from 'react-icons/fi';
import {AiFillEdit} from 'react-icons/ai';
import { FaTruck } from "react-icons/fa6";
import { IoMdPerson } from "react-icons/io";
import './TextArea.css'
import { sendRequest, API_ROOT } from '../../supplementary_components/requests';
import { addNotification } from '../../supplementary_components/store';
import { swapSVGWhileProcessing } from '../content_management/item_page/driver_page_components/payoutAdjustmentsSection';
const NoteBlock = styled.div`
    display: flex;
    justify-content:right;
`;
// background: ${mine ? "#00A4FF" : "#EBECEE"};
const NoteFrame = styled.div(({mine, relevant})=>`
    
    
    background: ${mine ? "var(--my-note-bg)" : "var(--extra-light-gray)"};
    border-radius:0.5rem;
    box-shadow: 0 0 0 0.03rem var(--light-gray);
    color: ${mine ? "white" : "var(--dark-gray)"};
    margin: 0.4rem 0.6rem;
    padding: 0.4rem 1.2rem 0.4rem 0.7rem;
    position: relative;
    opacity: ${relevant ? "1.0" : "0.5"};
    max-width:calc(100% - 2.5rem);
`);
const NoteText = styled.div`
    padding: 0.05rem 0.1rem;
    font-size:1.05rem;
    word-wrap: break-word;
    display:flex;
`;
const NoteType = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    margin-right:0.5rem;
    margin-left:-0.3rem;
`;
const UrgentIcon = styled.div`
    color: var(--alert-color);
    margin: auto 0;
    width:1.2rem;
    height:1.2rem;
    *{
        width: 100%;
        height: 100%;
    }
`;
const EditButton = styled.button(({mine})=>`
    position:absolute;
    top:0.5rem;
    right:0.0rem;
    margin-right:-0.35rem;
    background: none;
    border: none;
    *{
        color: ${mine ? "white" : "var(--dark-gray)"};
    }
`);

const AdditionalInfoBox = styled.div(({boxId, state, mine, changedExist})=>`
    
    *{
        color: ${mine ? "white" : "var(--dark-gray)"};;
    }
    height: 0px;
    overflow: hidden;
    transition: height  0.5s;
    ${state ? `height:calc(${getFullHeightWithMargin(document.getElementById(boxId))}px + 1.5rem);` : null};
    
`);
const InfoLine = styled.div`
    margin: 0.5rem 0;
    opacity:0.5;
`;
const TextNotBeingEdited = styled.div`
    display:grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
`;
const TextBeingEdited = styled.div`
    display:grid;
    grid-template-columns: 1fr 1fr;
`;
const EditOptionsButton = styled.button`
    padding: 0.2rem 0;
    background: none;
    border: none;
    text-decoration: underline;
`;
const getSVGFromTarget = (target) => {
    // If target is already an SVG, return it
    if (target && target.tagName === 'svg') {
        return target;
    }
    
    // If target is inside an SVG (like a path), traverse up to find the SVG
    let current = target;
    while (current && current.tagName !== 'svg' && current.tagName !== 'BUTTON') {
        current = current.parentNode;
    }
    
    // If we found an SVG, return it
    if (current && current.tagName === 'svg') {
        return current;
    }
    
    // If we found a button (or target is a button), query for SVG inside it
    if (current && current.tagName === 'BUTTON') {
        return current.querySelector('svg');
    }
    
    // If target itself is a button, query for SVG
    if (target && target.tagName === 'BUTTON') {
        return target.querySelector('svg');
    }
    
    return null;
};
const NoteItem = ({note, currentUser, objectType, objectId, editNote, removeNote})=>{  
    
    const [urgent, setUrgent] = useState(note.urgent);
    const [relevant, setRelevant] = useState(note.relevant);
    const [addInfoState, setAddInfoState] = useState(false);
    const [editMode, setEditMode] = useState(false);
    
    const OpenAdditionalInfo = ()=>{
        if(editMode)setEditMode(false);
        setAddInfoState(!addInfoState);
    }
    const authorMe = parseInt(note.authorId) === parseInt(currentUser.id);
    const borderColor = authorMe ? "rgba(240, 240, 240, 0.5)" : "rgba(var(--darkGrayRGB), 0.2)";
    const textColor = authorMe ? "white" : 'var(--dark-gray)';
    const noteEditTextareaRef = useRef(null);
    const NoteRef = useRef(null);
    const promiseGenerator = (payload) => {
        return new Promise((resolve, reject) => {
            const postSuccessAction = (responseData) => {
                if(payload.updatedNote){
                    editNote(payload.updatedNote);
                }
                if(payload.postSuccess){
                    payload.postSuccess(responseData);
                }
                resolve(responseData);
            };
            const postErrorAction = (error) => {
                addNotification({message:'Something went wrong',type:'alert'});
                reject(error);
            };
            const link = API_ROOT+`${objectType}/${payload.actionName || 'editNote'}/${objectId}`;
            sendRequest('PATCH', link, null, postSuccessAction, postErrorAction, payload.updatedNote);
        });
    };
    function updateNote(noteObject, svgElement, postSuccess, actionName){
        if(noteObject){
            noteObject.lastChangedBy = currentUser.firstName;
        }
        
        swapSVGWhileProcessing(promiseGenerator, svgElement, {
            actionName: actionName,
            updatedNote: noteObject,
            postSuccess: postSuccess
        }, null, '0.15rem', textColor);
    }

    const updateNoteText = (target)=>{
        note.noteMessage = noteEditTextareaRef.current.value;
         
        updateNote(note, getSVGFromTarget(target), ()=>{
            setEditMode(false);
            OpenAdditionalInfo();
        });        
    }
    const changeNotesUrgencyState = (target)=>{
        note.urgent = !note.urgent;
        updateNote(note, getSVGFromTarget(target), ()=>{
            setUrgent(!urgent);
            OpenAdditionalInfo();
        });
    }
    const changeNotesRelevancyState = (target)=>{
        note.relevant = !note.relevant
        if (!note.relevant)note.urgent = false;
        updateNote(note, getSVGFromTarget(target), ()=>{
            setRelevant(!relevant);
            OpenAdditionalInfo();
        });
    }
    const removeThisNote = (target) => {
        updateNote(note, getSVGFromTarget(target), (result)=>{
            removeNote(result);
        }, 'removeNote');
        // const link = API_ROOT+`${objectType}/removeNote/${objectId}`;
        // sendRequest('PATCH', link, null, removeNote, ()=>{addNotification({message:'Something went wrong',type:'alert'})}, note);
    }
    return <NoteBlock>
        {urgent?
            <UrgentIcon >
                <BsExclamationCircleFill />
            </UrgentIcon>
            :
            null
        }
        
        
        <NoteFrame mine={authorMe} relevant={relevant}>
            <EditButton mine={authorMe} ><BiDotsVerticalRounded onClick={OpenAdditionalInfo}/></EditButton>
            
            {editMode ? <TextareaAutosize
                ref={noteEditTextareaRef}
                minRows={1}
                maxRows={15} 
                className="noteBeingEdited"
                style={{
                    // marginLeft:`1rem`,
                    width : (NoteRef !== null && NoteRef.current && NoteRef.current.clientWidth) ? `${NoteRef.current.clientWidth}px` : '100%',
                    border : `thin solid ${borderColor}`,
                    color: textColor
                }}
                defaultValue= {note.noteMessage}
                /> 
                : 
                <NoteText ref={NoteRef}>
                    {note.type ? 
                        <NoteType  title={note.label ? note.label : null}  >
                            <GenerateIconByNoteType  type={note.type} />
                        </NoteType> 
                    : null}{note.noteMessage}
                </NoteText>}
                <AdditionalInfoBox boxId={note.id}  state={addInfoState}  mine={authorMe} changedExist={note.lastChangedTime != null}>
                <InfoLine id={note.id}>
                    Created: {note.dateTime?.substring(0, 11)} {note.authorName} < br/>
        { note.lastChangedTime != null ? <> Edited: {note.lastChangedTime?.substring(0, 11)} {note.lastChangedBy}</> : null}
                </InfoLine> 
                { editMode ?
                    <TextBeingEdited>
                        <EditOptionsButton onClick={(e)=>{
                            updateNoteText(e.target);
                        }}> 
                            <FiCheck />
                        </EditOptionsButton>
                        <EditOptionsButton onClick={()=>{
                            setEditMode(false);
                            
                        }}> 
                            <VscChromeClose />
                        </EditOptionsButton>
                    </TextBeingEdited>
                :
                    <TextNotBeingEdited>
                    <EditOptionsButton onClick={()=>{
                        if (relevant){
                            setEditMode(true);
                        }
                        
                    }} > 
                        {relevant ? <AiFillEdit /> : null} 
                    </EditOptionsButton>
                    

                    
                    <EditOptionsButton 
                        onClick={(e)=>{
                            if (relevant){
                                changeNotesUrgencyState(e.target);
                            }
                        }}> 
                        {relevant ? 
                            <>
                                {urgent ? <BsExclamationCircle /> : <BsExclamationCircleFill />}
                            </> : null
                        }
                    </EditOptionsButton>
                    
                    
                    <EditOptionsButton onClick={(e)=>{
                        changeNotesRelevancyState(e.target);
                        
                    }}> 
                        { relevant ? <BsEyeSlash /> : <BsEyeFill />  }
                    </EditOptionsButton>
                    
                    
                    <EditOptionsButton onClick={(e)=>{
                        removeThisNote(e.target);
                    }}> 
                        <BsTrash />
                    </EditOptionsButton>
                </TextNotBeingEdited>
                }
                
                
            </AdditionalInfoBox>
            
        </NoteFrame>
    </NoteBlock> 
}
export default NoteItem;

function getFullHeightWithMargin(elem){
    if(!elem)return null;
    var height = elem.offsetHeight;
    height += parseInt(window.getComputedStyle(elem).getPropertyValue('margin-top'));
    height += parseInt(window.getComputedStyle(elem).getPropertyValue('margin-bottom'));

    return height;
}
//driver 
//

export const GenerateIconByNoteType = ({type}) => {
    switch (type) {
        case "drivers":
            return <IoMdPerson />
        case "trucks":
            return <FaTruck />
        case "trailers":
            return <TrailerSVG />
        default:
            return <></>;
    }
}
export const TrailerSVG = () => {
    return <svg fill="white" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" 
    width="1.2rem" height="1.2rem" viewBox="0 0 481.815 481.815"
    space="preserve">
    <g>
        <g>
            <path d="M0,288.732h381.769c14.812,14.611,28.598,30.48,34.652,50.79c0.092,0.321,0.244,0.589,0.361,0.882
                c0.067,5.049,0.1,10.103,0.16,15.156h-15.594c-6.5,0-11.773,5.266-11.773,11.773s5.273,11.778,11.773,11.778h41.217
                c6.5,0,11.773-5.271,11.773-11.778s-5.273-11.773-11.773-11.773h-5.983c-0.136-22.281-0.497-44.551-0.705-66.82h45.938V100.752H0
                V288.732z M416.253,288.732c0.032,3.158,0.06,6.308,0.092,9.458c-2.452-3.219-4.997-6.393-7.666-9.458H416.253z"/>
            <path d="M75.292,298.92c22.684,0,41.076,18.39,41.076,41.067c0,22.694-18.392,41.076-41.076,41.076
                c-22.68,0-41.072-18.382-41.072-41.076C34.219,317.31,52.611,298.92,75.292,298.92z"/>
            <path d="M163.435,298.92c22.686,0,41.074,18.39,41.074,41.067c0,22.694-18.388,41.076-41.074,41.076
                c-22.68,0-41.072-18.382-41.072-41.076C122.363,317.31,140.754,298.92,163.435,298.92z"/>
        </g>
    </g>
</svg>
}